declare global {
    interface Window {
        __browserdebugV1?: { connected?: boolean }
        __browserdebug?: {
            connected?: boolean
            handles?: BrowserDebugHandle[]
            registerHandle?: (handle: BrowserDebugHandle) => number
        }
        __browserdebugToken?: string
        __browserdebugBaseUrl?: string
        __secureblobBrowserDebugLoading?: boolean
        __secureblobBrowserDebugRetryTimer?: number
        __secureblobBrowserDebugRetryCount?: number
    }
}

export interface BrowserDebugHandle {
    name: string
    description: string
    handle: unknown
}

export function registerBrowserDebugHandle(handle: BrowserDebugHandle) {
    const surface = window.__browserdebug ?? { handles: [] }
    if (surface.registerHandle) {
        return surface.registerHandle(handle)
    }
    surface.handles ??= []
    surface.handles.push(handle)
    window.__browserdebug = surface
    return surface.handles.length - 1
}

export function installBrowserDebugAgent() {
    const token = import.meta.env.VITE_BROWSERDEBUG_TOKEN
    if (!token || import.meta.env.VITE_BROWSERDEBUG_ENABLED === 'false') return
    if (window.__browserdebug?.connected || window.__browserdebugV1?.connected || window.__secureblobBrowserDebugLoading) return

    if (window.__secureblobBrowserDebugRetryTimer != null) {
        window.clearTimeout(window.__secureblobBrowserDebugRetryTimer)
        window.__secureblobBrowserDebugRetryTimer = undefined
    }
    window.__secureblobBrowserDebugLoading = true
    const baseUrl = (import.meta.env.VITE_BROWSERDEBUG_BASE_URL || 'https://browserdebug.hoglundit.se').replace(/\/+$/, '')
    const script = document.createElement('script')
    script.async = true
    window.__browserdebugToken = token
    window.__browserdebugBaseUrl = baseUrl
    script.src = `${baseUrl}/agent/v1.js#${token}`
    script.addEventListener('load', () => {
        window.__secureblobBrowserDebugLoading = false
        window.__secureblobBrowserDebugRetryCount = 0
    }, { once: true })
    script.addEventListener('error', () => {
        window.__secureblobBrowserDebugLoading = false
        script.remove()
        const retryCount = Math.min((window.__secureblobBrowserDebugRetryCount ?? 0) + 1, 6)
        window.__secureblobBrowserDebugRetryCount = retryCount
        const delayMs = Math.min(1_000 * 2 ** (retryCount - 1), 30_000)
        window.__secureblobBrowserDebugRetryTimer = window.setTimeout(() => {
            window.__secureblobBrowserDebugRetryTimer = undefined
            installBrowserDebugAgent()
        }, delayMs)
    }, { once: true })
    document.documentElement.appendChild(script)
}
